module.exports = __webpack_public_path__ + "img/byCompany.1d711308.svg";